<template>
  <div class="wrapper_group_dashboard">
    <div class="group_dashboard">
      <div class="banking_information">
        <breadcrumb :items="breadcrumbItems" class="banking-breadcrumb" />
        <div class="title">
          <h2>Banking Information</h2>
          <button v-b-modal.add_bank_info class="add_bank_info">
            <i class="fas fa-plus"></i>
            <span style="margin-left: 5px">Add Banking Info</span>
          </button>
        </div>
        <div class="table_container">
          <div class="bank_info">
            <table>
              <thead>
                <tr>
                  <td>S.No</td>
                  <td>Account Name</td>
                  <td>Routing Number</td>
                  <td>Bank Name</td>
                  <td>Account Number</td>
                  <td>Account Type</td>
                  <td>Account Holder Type</td>
                  <td>Actions</td>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in groupBanks"
                  :key="index"
                  :class="item.is_primary ? 'bank-primary-backgroud' : null"
                >
                  <td>
                    <strong>{{ index + 1 }}</strong>
                  </td>
                  <td>{{ item.bank_accountname }}</td>
                  <td>{{ item.bank_routing }}</td>
                  <td>{{ item.bank_name }}</td>
                  <td>
                    <div class="account-number-cell">
                      <span>
                        {{ visibleAccounts.has(item.bank_id) ? item.bank_account_full : item.bank_account4 }}
                      </span>
                      <button
                        class="eye-toggle-btn"
                        @click.prevent="toggleAccountVisibility(item.bank_id)"
                        :title="visibleAccounts.has(item.bank_id) ? 'Hide account number' : 'Show full account number'"
                      >
                        <span class="eye-icon-wrap">
                          <!-- Open eye (visible state) -->
                          <svg v-if="visibleAccounts.has(item.bank_id)" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" class="eye-svg">
                            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                            <circle cx="12" cy="12" r="3"/>
                          </svg>
                          <!-- Closed eye with slash (hidden state) — pupil always visible -->
                          <svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" class="eye-svg">
                            <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/>
                            <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/>
                            <circle cx="12" cy="12" r="3"/>
                            <line x1="1" y1="1" x2="23" y2="23"/>
                          </svg>
                        </span>
                      </button>
                    </div>
                  </td>
                  <td>
                    {{ item.account_type ? item.account_type : "--" }}
                  </td>
                  <td>
                    {{ item.account_holder_type ? item.account_holder_type : "--" }}
                  </td>
                  <td>
                    <div class="icons">
                      <template v-if="item.is_primary">
                        <div class="banking_status-listActive">
                          <i class="fas fa-check-circle"></i>
                          <span class="status">Active</span>
                        </div>
                      </template>
                      <template v-else>
                        <div class="">
                          <a
                            href="javascript:void(0);"
                            @click.prevent="setPrimaryBank(item.bank_id)"
                          >
                            <img src="@/assets/images/landscape-phone.svg" width="22" />
                            Set as Primary
                          </a>
                        </div>
                        <delete-button @click.native.prevent="deleteBank(item.bank_id)" />
                      </template>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <AddBankInfo />
      </div>
    </div>
  </div>
</template>

<script>
import Api from "@/resource/Api";
import { mapGetters } from "vuex";
import AddBankInfo from "@/pages/Bank/AddBankInfo.vue";

export default {
  components: { AddBankInfo },
  data: () => {
    return {
      breadcrumbItems: [{ title: "Banking Information", active: true }],
      visibleAccounts: new Set(),
    };
  },
  computed: {
    ...mapGetters({
      groupBanks: "groupBanks",
      groupPaymentType: "groupPaymentType",
    }),
  },
  methods: {
    toggleAccountVisibility(bankId) {
      const updated = new Set(this.visibleAccounts);
      if (updated.has(bankId)) {
        updated.delete(bankId);
      } else {
        updated.add(bankId);
      }
      this.visibleAccounts = updated;
    },
    setPrimaryBank(bankId) {
      let url = `set-primary-bank?bank_id=${bankId}`;
      this.$store.commit("setDialogClass", "group-app-confirm-dialog");
      this.$confirm({
        title: "Set Primary Bank",
        message: `Do you want to set this bank to primary?`,
        button: { no: "No", yes: "Yes" },
        callback: (confirm) => {
          if (confirm) {
            let loader = this.$loading.show();
            Api.put(url)
              .then((res) => {
                this.$store.dispatch("getGroupBanks");
                this.$notify(res.data.message);
              })
              .catch((err) => {
                this.$notify(err.response.data.message, "Error", "danger");
              })
              .finally(() => {
                loader.hide();
              });
          }
        },
      });
    },
    deleteBank(bankId) {
      let url = `delete-bank?bank_id=${bankId}`;
      this.$store.commit("setDialogClass", "group-app-warning-dialog");
      this.$confirm({
        title: "Delete Bank",
        message: `Do you want to delete this bank?`,
        button: { no: "No", yes: "Yes" },
        callback: (confirm) => {
          if (confirm) {
            let loader = this.$loading.show();
            Api.delete(url)
              .then((res) => {
                this.$store.dispatch("getGroupBanks");
                this.$notify(res.data.message);
              })
              .catch((err) => {
                this.$notify(err.response.data.message, "Error", "danger");
              })
              .finally(() => {
                loader.hide();
              });
          }
        },
      });
    },
  },
  mounted() {
    if (this.groupPaymentType !== "EFT") {
      this.$router.push({ name: "GroupDashboard" });
    }
    this.$store.dispatch("getGroupBanks");
    let loader = this.$loading.show();
    setTimeout(() => {
      loader.hide();
    }, 1000);
  },
};
</script>

<style src="@/assets/css/group_dashboard/banking_information.css" scoped></style>

<style scoped>
.account-number-cell {
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
}

.eye-toggle-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 23px;
  height: 23px;
  border: none;
  border-radius: 50%;
  background: linear-gradient(135deg, #29b6e8, #1a8cff);
  color: #ffffff;
  cursor: pointer;
  flex-shrink: 0;
  box-shadow: 0 2px 6px rgba(26, 140, 255, 0.4);
  transition: background 0.15s ease, transform 0.1s ease;
  padding: 0;
}

.eye-toggle-btn:hover {
  background: linear-gradient(135deg, #1aa8d8, #0070e0);
  transform: scale(1.08);
}

.eye-toggle-btn:active {
  transform: scale(0.95);
}

.eye-icon-wrap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.eye-svg {
  width: 16px;
  height: 16px;
  color: #ffffff;
  display: block;
}
</style>

<style>
.select_section .custom-file-label {
  font-size: 16px;
  border: 1px solid #dee2e5;
  border-radius: 8px;
}
.select_section .custom-file-label .form-file-text {
  display: none !important;
}
.select_section .custom-file-label::after {
  right: unset;
  left: 0;
  bottom: 0;
  height: unset;
  background: #03c3ec33;
  margin: 3px 6px;
  padding: 3px 15px;
  border-radius: 8px;
  font-size: 14px;
  color: #5e5e5e;
  border: none;
  cursor: pointer;
}
.select_section .custom-file {
  width: 290px;
}
#add_group_user .form-text {
  margin-top: 15px !important;
}
#add_group_user .text-muted {
  color: #03c3ec !important;
}
@media only screen and (max-width: 991px) {
  .select_section .custom-file-label {
    font-size: 12px;
  }
  .select_section .custom-file-label::after {
    font-size: 12px;
  }
}
@media only screen and (max-width: 575px) {
  .select_section .custom-file {
    width: 100%;
  }
}
</style>